// extracted by mini-css-extract-plugin
export var table = "_yr-0";